import routes from '@/modules/control/control-routes';
import store from '@/modules/control/control-store';

export default {
    routes,
    store,
}
